/* eslint-disable max-len */
var UI_SCROLL_HORIZONTAL = {
  "default": 'M15.5003 1.51123V30.5112H1.50033V1.51123H15.5003ZM16.5003 30.5112V1.51123H30.5003V30.5112H16.5003Z',
  globetrotter: 'M15.5003 1.51123V30.5112H1.50033V1.51123H15.5003ZM16.5003 30.5112V1.51123H30.5003V30.5112H16.5003Z'
};

export { UI_SCROLL_HORIZONTAL };
//# sourceMappingURL=UI_SCROLL_HORIZONTAL.js.map
